module.exports = __webpack_public_path__ + "img/20300____2.prt.b014498e.jpg";